import * as actionTypes from './actionTypes';
import * as api from '../api';
import { createActionObject, getAjaxFunc } from '../../helpers/common';
import { fetchStationTimeOffset } from '../../helpers/api';
import { getStationFields } from '../../stations-mgmt/api';

export const getStationTimeOffset = station => dispatch => {
  var targetDate = new Date();
  var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC 
  return fetchStationTimeOffset(timestamp, station.latitude, station.longitude)
    .then(stationTimeOffset => dispatch(
      createActionObject(
        actionTypes.SET_STATION_TIME_OFFSET,
        { stationTimeOffset }
      )
    ));
}

export const selectStation = stationId => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_STATION,
    { stationId }
  )
);

export const toggleField = fieldName => dispatch => dispatch(
  createActionObject(
    actionTypes.TOGGLE_FIELD,
    { fieldName }
  )
)

export const selectView = view => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_VIEW_PERIOD,
    { view }
  )
);

export const selectDay = day => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_DAY,
    { day }
  )
)

export const selectMonth = month => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_MONTH,
    { month }
  )
);

export const selectYear = year => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_YEAR,
    { year }
  )
);

export const selectAgg = agg => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_AGG,
    { agg }
  )
);

export const selectFields = selectFields => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_FIELDS,
    { selectFields }
  )
);

export const resetSelectFields = () => dispatch => dispatch(
  createActionObject(
    actionTypes.RESET_SELECT_FIELDS,
    { selectFields: [] }
  )
);

export const selectFieldsIndex = selectFieldsIndex => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_FIELDS_INDEX,
    { selectFieldsIndex }
  )
);

const sortByTimestamp = (a, b) => {
  if (a.timestamp < b.timestamp)
    return -1;
  if (a.timestamp > b.timestamp)
    return 1;
  return 0;
}


export const loadGraphData = (station, graphDate, stationTimeOffset, apiFun, successActionType, dispatch) => {
  let graphTimestamp = graphDate.getTime();
  let graphTimeInSeconds = (graphTimestamp / 1000) + graphDate.getTimezoneOffset() * 60;

  var offsets = stationTimeOffset.dstOffset * 1000 + stationTimeOffset.rawOffset * 1000;
  var destinationDate = new Date(graphTimeInSeconds * 1000 + offsets);

  return apiFun(station.id, destinationDate.getTime())
    .then(({ data }) => {
      var dataArr = JSON.parse(data);
      dataArr.sort(sortByTimestamp);
      dispatch(
        createActionObject(
          successActionType,
          { data: dataArr }
        )
      )
    })
}

export const loadDayData = (year, month, day, station, stationTimeOffset) => dispatch => getAjaxFunc(
  actionTypes.FETCH_DAY_DATA_REQUEST,
  "",
  actionTypes.FETCH_DAY_DATA_FAILURE,
  "",
  dispatch
)(
  () => {
    let graphDate = new Date(year, month - 1, day);
    return loadGraphData(
      station,
      graphDate,
      stationTimeOffset,
      api.loadDayData,
      actionTypes.FETCH_DAY_DATA_SUCCESS,
      dispatch
    );
  }
)()

export const loadMonthData = (year, month, station, stationTimeOffset) => dispatch => getAjaxFunc(
  actionTypes.FETCH_MONTH_DATA_REQUEST,
  "",
  actionTypes.FETCH_MONTH_DATA_FAILURE,
  "",
  dispatch
)(
  () => {
    let graphDate = new Date(year, month - 1, 1);
    return loadGraphData(
      station,
      graphDate,
      stationTimeOffset,
      api.loadMonthData,
      actionTypes.FETCH_MONTH_DATA_SUCCESS,
      dispatch
    );
  }
)()

export const loadYearData = (year, station, stationTimeOffset) => dispatch => getAjaxFunc(
  actionTypes.FETCH_YEAR_DATA_REQUEST,
  "",
  actionTypes.FETCH_YEAR_DATA_FAILURE,
  "",
  dispatch
)(
  () => {
    let graphDate = new Date(year, 0, 1);
    return loadGraphData(
      station,
      graphDate,
      stationTimeOffset,
      api.loadYearData,
      actionTypes.FETCH_YEAR_DATA_SUCCESS,
      dispatch
    );
  }
)()

export const fetchGraphReferences = stationId => dispatch => getAjaxFunc(
  actionTypes.FETCH_GRAPH_REF_REQUEST,
  "",
  actionTypes.FETCH_GRAPH_REF_FAILURE,
  "",
  dispatch
)(
  () => api.loadGraphReferences(stationId)
    .then(({ data }) => {
      let fieldVisibleMapping = {};
      for (let i = 0; i < data.length; i++) {
        fieldVisibleMapping[data[i].fieldName] = true;
      };

      dispatch(
        createActionObject(
          actionTypes.FETCH_GRAPH_REF_SUCCESS,
          { data, fieldVisibleMapping }
        )
      )
    })
)();

export const loadYearIndices = () => dispatch => getAjaxFunc(
  actionTypes.FETCH_YEAR_INDICES_REQUEST,
  "",
  actionTypes.FETCH_YEAR_INDICES_FAILURE,
  "",
  dispatch
)(
  () => api.loadYearIndices()
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.FETCH_YEAR_INDICES_SUCCESS,
            { yearIndices: data }
          )
        )
      }
    })
)();

export const getFindStationFields = (station) => dispatch => getAjaxFunc(
  actionTypes.GET_FIND_STATIONS_FIELDS_REQUEST,
  "",
  actionTypes.GET_FIND_STATIONS_FIELDS_FAILURE,
  "",
  dispatch
)(
  () => getStationFields(station)
    .then((response) => {
      var data;
      response.text().then(function (text) {
        data = JSON.parse(text);
        switch (response.status) {
          case 200:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS,
                { findStationFields: data }
              )
            );
            break;
          case 500:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS,
                { findStationFields: [] }
              )
            );
            break;
          default:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_STATIONS_FIELDS_FAILURE,
              )
            );
            break;
        }
      });
    })
)()

export const getQueryHistoryData = (apiData) => dispatch => getAjaxFunc(
  actionTypes.GET_QUERY_HISTORY_REQUEST,
  "",
  actionTypes.GET_QUERY_HISTORY_FAILURE,
  "",
  dispatch
)(
  () => api.queryHistoryData(apiData)
    .then(({ data, status }) => {
      if (status === 200) {
        // Log the data before dispatching the success action
        dispatch(
          createActionObject(
            actionTypes.GET_QUERY_HISTORY_SUCCESS,
            { queryHistoryData: data }
          )
        )
      }
    })
)()
